import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import {
  tableHeaderBackgroundColor,
  tableHeaderTextColor,
  textFieldFocusStyle,
} from "../common/commonButtonStyles";

//inline styles
const InlineStyles = {
  TableHeader: {
    backgroundColor: tableHeaderBackgroundColor,
    color: tableHeaderTextColor,
    position: "sticky",
    top: 0,
    zIndex: 1,
    height: "50px",
    width:"200px"
  },
  TableCells: {
    color: tableHeaderTextColor,
    fontSize: "12px",
    height: "44px",
    padding: "0px"
  },
  TableBodyRows: {
    border: "1px solid #ddd",
    marginTop: "10px",
    paddingTop: "15px",
    verticalAlign: "top",
  },
  TableBodyRowCells: {
    height: "20px",
    padding: "0px"
  },
  insurerTableCell: {
    height: "20px",
    padding: "3px",
    width:"200px"
  },
  insurer: {
    position: "relative",
    width: "200px",
    height: "32px"
  },
  MoreVertIconStyle: {
    color: "FF5A01",
    background: "transparent",
    cursor: "pointer",
    transform: "rotate(90deg)",
  }
};
export const AddParticipatingInsurerDetails = ({
  handleInputChange,
  row,
  viewMode,
  validationStatus
}) => {
  return (
    <Table>
      <TableHead style={InlineStyles.TableHeader}>
        <TableRow style={{ backgroundColor: tableHeaderBackgroundColor }}>
          <TableCell className="TableCell" style={{ color: tableHeaderTextColor }}>Participating Insurer</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow style={InlineStyles.TableBodyRows}>
          <TableCell sx={InlineStyles.insurerTableCell}>
            <TextField
              value={row.participating_insurer}
              onChange={(e) =>
                handleInputChange("participating_insurer", e.target.value)
              }
              sx={{
                position: "relative",
                width: "200px",
                height: "32px",
                ...textFieldFocusStyle,
              }}
              size="small"
              placeholder="Enter Details Here"
              disabled={viewMode}
            />
            <br />
            {validationStatus?.participating_insurer && (
              <span style={{ color: "red" }}>
                {validationStatus?.participating_insurer}
              </span>
            )}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
